export default __webpack_public_path__ + "static/media/profile-2.4124ce5d.jpg";